import axios from 'axios';
import { config_headers, URL_API,servicelist } from '../Config';

export const P215GetColumnList= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_boq_head_info`), body, authorization )
                .then(res => {
                    resolve(res.data);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P215GetDataList= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers); 
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_result_detail_info`), body, authorization )
                .then(res => {
                    resolve(res.data);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P215UpdateData= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);   
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_result_detail_update`), body, authorization)  
                .then(res => {
                    resolve(res);
                })
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}



